import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-light mt-auto thisfooter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "footer-copyright text-center py-3" }, [
      _createTextVNode(" © Copyright "),
      _createElementVNode("span", { id: "copy_right_year" })
    ], -1)
  ])))
}